// base
import React from "react";
import { Link } from "react-router-dom";

// components
import { Button, StateButton } from "..";
// assets
import arrow from "../../assets/images/transactions/arrow.png";
import "./transactionsComponentTable.scss";
import {
  substring,
  fromNow,
  wei2Daon,
  wei2Gwei,
  arc721abiReplace,
} from "../../../helper";

import { getTokenURI } from "../../../api";

async function tokenIDClick(address, tokenID) {
  const res = await getTokenURI(address, Number(tokenID) + 1);
  if (res) {
    window.open(res.data.tokenURI);
  }
}

function tokenIDParse(tokenID) {
  return tokenID.replace(/(^0+)/, "") != "" ? tokenID.replace(/(^0+)/, "") : 0;
}

const ContractTransactionsComponentTable = ({ props }) => {
  if (!props) return null;
  let tx = props.transactions;
  return (
    <div className="responsive_table">
      <table className={`tokenTransaction_table `}>
        <thead>
          <tr>
            <th>TX HASH</th>
            <th>BLOCK #</th>
            <th>Method</th>

            <th>FROM</th>
            <th>
              <img src={arrow} alt="에서" />
            </th>
            <th>TO</th>
            <th>TOKENID</th>
            <th>TOKEN</th>
            <th>STATUS</th>
            {/* {props.type !== "simple" && <th>TIME</th>} */}
            {/* <th>AMOUNT</th>
            <th>GAS PRICE(Gwei)</th> */}
          </tr>
        </thead>

        <tbody>
          {tx &&
            tx.length > 0 &&
            tx.map((item, index) => (
              <tr key={index}>
                <td>
                  <Button
                    color="blue"
                    size="wide"
                    link={`/transaction/${item.hash}`}
                    tooltip={item.hash}
                  >
                    {substring(item.hash, 10)}
                  </Button>
                </td>

                <td>
                  <Link
                    to={`/blocks/detail/${item.blockNumber}`}
                    className="link"
                  >
                    {item.blockNumber}
                  </Link>
                </td>
                <td>
                  {props.type == "ARC721" ? arc721abiReplace(item.abi) : ""}
                </td>

                <td>
                  <Button
                    color={props.pageName === "Account" ? "gray" : "blue"}
                    size="wide"
                    tooltip={item.from}
                    link={`/account/${item.from}`}
                    disable={props.pageName === "Account" ? true : false}
                  >
                    {substring(item.from, 8)}
                  </Button>
                </td>
                <td>
                  <img src={arrow} alt="에서" />
                </td>
                <td>
                  <Button
                    color="blue"
                    size="wide"
                    link={`/account/${item.to}`}
                    tooltip={item.to}
                  >
                    {substring(item.to, 8)}
                  </Button>
                </td>
                <td>
                  <button
                    onClick={() =>
                      tokenIDClick(item.contract, tokenIDParse(item.tokenID))
                    }
                  >
                    {tokenIDParse(item.tokenID)}
                  </button>
                </td>
                <td>
                  <Button
                    color="blue"
                    size="wide"
                    link={`/contract/${item.contract}`}
                    tooltip={item.contract}
                  >
                    {item.contract_name
                      ? item.contract_name
                      : substring(item.contract, 8)}
                    {/* {} */}
                  </Button>
                </td>
                <td>
                  <StateButton
                    status={item.status}
                    reason={item.reason}
                    style={{ cursor: "default" }}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContractTransactionsComponentTable;
